import domLoaded from 'dom-loaded';

domLoaded.then(() => {
  const stateSelect = document.querySelector('#stateSelect');

  if (stateSelect) {
    stateSelect.addEventListener('change', (event) => {
      const state = event.target.value;
      if (state) {
        window.location.href = `/states/${ state }`;
      }
    });
  }
});
